import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import type { BlogCategory } from "@/pages/blog/blogData";

interface CategoryHeroProps {
  category: BlogCategory;
  count: number;
  titleOverride?: string;
}

export default function CategoryHero({ category, count, titleOverride }: CategoryHeroProps) {
  const title = titleOverride ?? `${category.name}: Guias, Dicas e Tutoriais`;

  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="absolute inset-0 nx-grid opacity-30"></div>
      <div className="nx-glow absolute -top-40 right-0 h-[420px] w-[420px] animate-pulseGlow"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pt-28 pb-14 md:px-8 md:pt-36 md:pb-16">
        <Reveal>
          <nav aria-label="Trilha de navegação" className="flex flex-wrap items-center gap-2 text-xs text-background-400">
            <Link to="/" className="transition-colors hover:text-background-50">
              Início
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <Link to="/blog" className="transition-colors hover:text-background-50">
              Blog
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-background-200">{category.name}</span>
          </nav>
        </Reveal>

        <div className="mt-6 flex items-start gap-4">
          <Reveal>
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl border border-background-50/15 bg-background-50/5 text-accent-300">
              <i className={`${category.icon} text-3xl`} aria-hidden="true"></i>
            </span>
          </Reveal>
          <div>
            <Reveal delay={80}>
              <h1 className="font-heading text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
                {title}
              </h1>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-4 max-w-3xl text-base leading-relaxed text-background-200">
                {category.longDescription}
              </p>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-3.5 py-1.5 text-xs text-background-300">
                <i className="ri-article-line" aria-hidden="true"></i>
                {count} {count === 1 ? "artigo publicado" : "artigos publicados"}
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}